/* American Threads Co - optional personalisation fields on the product page.

   Driven by the product metafield atc.custom_fields (injected as
   window.ATC_CUSTOM_FIELDS from snippets/stylesheets.liquid). Falls back to
   the BOO CREW name+number config so the older products keep working.

   Field types:
     (none) / "text"  - single line, with optional mode: "upper" | "digits"
     "select"         - dropdown, options: [...], placeholder = the empty row
     "file"           - one upload, accept: "image/*,.pdf,..."
     "filelist"       - 1..max uploads the shopper adds himself. min slots are
                        shown up front, an add button appends another up to
                        max, each extra slot carries a remove link, and the
                        slots renumber themselves so the line item properties
                        are always "<name> 1" .. "<name> N" with no gaps.
     "textarea"       - multi-line notes

   Shopify stores one file per line item property, so several photos means
   several properties - hence filelist rather than a multiple file input.

   EVERY field is optional. An empty field is disabled for the instant the
   cart request is built, so it never reaches the order. The strip re-queries
   the DOM every time because filelist slots appear and disappear after wiring.
*/
(function () {
  var DEFAULT_CONFIG = {
    title: 'Personalise the back',
    hint: 'Leave both blank to receive the design exactly as pictured (BOO CREW / 00).',
    fields: [
      { name: 'Crew name', label: 'Crew name &mdash; up to 12 characters', max: 12, mode: 'upper', placeholder: 'BOO CREW' },
      { name: 'Number', label: 'Number &mdash; up to 2 digits', max: 2, mode: 'digits', placeholder: '00' }
    ]
  };

  var UID = 0;

  function config() {
    var c = window.ATC_CUSTOM_FIELDS;
    if (c && c.fields && c.fields.length) return c;
    return DEFAULT_CONFIG;
  }

  function addStyle() {
    if (document.getElementById('atc-ct-style')) return;
    var s = document.createElement('style');
    s.id = 'atc-ct-style';
    s.textContent = [
      '.atc-ct{margin:18px 0;border:1px solid rgba(255,255,255,.22);border-radius:10px;}',
      '.atc-ct__sum{list-style:none;cursor:pointer;display:flex;align-items:center;gap:12px;padding:15px 16px;}',
      '.atc-ct__sum::-webkit-details-marker{display:none;}',
      '.atc-ct__sumtext{flex:1 1 auto;min-width:0;}',
      '.atc-ct__title{font-size:13px;letter-spacing:.06em;text-transform:uppercase;margin:0;}',
      '.atc-ct__sub{font-size:12px;line-height:1.4;margin:3px 0 0;opacity:.6;}',
      '.atc-ct__chev{flex:0 0 auto;width:9px;height:9px;margin-inline-end:4px;',
      'border-right:2px solid currentColor;border-bottom:2px solid currentColor;',
      'transform:rotate(45deg) translate(-2px,-2px);transition:transform .2s ease;}',
      '.atc-ct[open] .atc-ct__chev{transform:rotate(-135deg) translate(-2px,-2px);}',
      '.atc-ct__body{padding:0 16px 16px;}',
      '.atc-ct__hint{font-size:12px;line-height:1.45;margin:0 0 12px;opacity:.65;}',
      '.atc-ct__row{display:flex;gap:10px;flex-wrap:wrap;}',
      '.atc-ct__field{flex:1 1 150px;display:flex;flex-direction:column;gap:5px;}',
      '.atc-ct__field--wide{flex:1 1 100%;}',
      '.atc-ct__field label{font-size:12px;opacity:.8;}',
      '.atc-ct__field input[type="text"],.atc-ct__field select,.atc-ct__field textarea{width:100%;box-sizing:border-box;padding:10px 12px;border-radius:8px;border:1px solid rgba(255,255,255,.3);background:transparent;color:inherit;font:inherit;font-size:14px;}',
      '.atc-ct__field textarea{min-height:64px;resize:vertical;}',
      '.atc-ct__field select option{color:#000;background:#fff;}',
      '.atc-ct__field input[type="text"]:focus,.atc-ct__field select:focus,.atc-ct__field textarea:focus{outline:none;border-color:currentColor;}',
      '.atc-ct__field input.atc-ct-upper{text-transform:uppercase;}',
      '.atc-ct__file{position:relative;display:flex;align-items:center;gap:12px;flex-wrap:wrap;}',
      '.atc-ct__fileinput{position:absolute;width:1px;height:1px;padding:0;margin:0;opacity:0;overflow:hidden;clip:rect(0 0 0 0);border:0;}',
      '.atc-ct__filebtn{display:inline-block;flex:0 0 auto;padding:11px 16px;border-radius:8px;border:1px solid rgba(255,255,255,.35);font-size:14px!important;line-height:1;opacity:1!important;cursor:pointer;-webkit-tap-highlight-color:transparent;}',
      '.atc-ct__fileinput:focus + .atc-ct__filebtn{border-color:currentColor;}',
      '.atc-ct__filename{flex:1 1 120px;min-width:0;font-size:12.5px;line-height:1.4;opacity:.65;word-break:break-word;}',
      '.atc-ct__slot{display:flex;flex-direction:column;gap:5px;margin-bottom:14px;}',
      '.atc-ct__slot:last-child{margin-bottom:0;}',
      '.atc-ct__addbtn{align-self:flex-start;margin-top:12px;padding:9px 14px;border-radius:8px;border:1px dashed rgba(255,255,255,.4);background:transparent;color:inherit;font:inherit;font-size:13px;cursor:pointer;-webkit-tap-highlight-color:transparent;}',
      '.atc-ct__addbtn[hidden]{display:none;}',
      '.atc-ct__rm{flex:0 0 auto;border:0;background:transparent;color:inherit;font:inherit;font-size:12px;opacity:.55;text-decoration:underline;cursor:pointer;padding:4px 0;}',
      '.atc-ct__rm[hidden]{display:none;}',
      '.atc-ct__count{font-size:11.5px;line-height:1.45;margin:8px 0 0;opacity:.5;}',
      '.atc-ct__note{font-size:11.5px;line-height:1.45;margin:10px 0 0;opacity:.55;}',
      '@media (max-width:749px){.atc-ct__field input[type="text"],.atc-ct__field select,.atc-ct__field textarea,.atc-ct__filebtn{font-size:16px!important;}}'
    ].join('');
    document.head.appendChild(s);
  }

  function mainForm() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      if (f.closest('.card, .product-card, product-card, .resource-list__item, .quick-add')) continue;
      return f;
    }
    return null;
  }

  function esc(v) {
    return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function build(cfg) {
    var wrap = document.createElement('details');
    wrap.className = 'atc-ct';
    wrap.setAttribute('data-atc-ct', '');

    var html = [];
    html.push("<summary class='atc-ct__sum'>");
    html.push("<span class='atc-ct__sumtext'>");
    html.push("<p class='atc-ct__title'>" + esc(cfg.title || 'Personalise this') + "</p>");
    html.push("<p class='atc-ct__sub'>" + esc(cfg.summary || 'Optional &ndash; tap to add') + "</p>");
    html.push("</span>");
    html.push("<i class='atc-ct__chev' aria-hidden='true'></i>");
    html.push("</summary>");

    html.push("<div class='atc-ct__body'>");
    if (cfg.hint) html.push("<p class='atc-ct__hint'>" + esc(cfg.hint) + "</p>");
    html.push("<div class='atc-ct__row'>");

    cfg.fields.forEach(function (f, i) {
      var id = 'atc-ct-f' + i;
      var type = f.type || 'text';

      if (type === 'filelist') {
        html.push(
          "<div class='atc-ct__field atc-ct__field--wide' data-atc-filelist='" + esc(f.name || 'Photo') + "'" +
          " data-atc-min='" + (parseInt(f.min, 10) || 1) + "'" +
          " data-atc-max='" + (parseInt(f.max, 10) || 8) + "'" +
          " data-atc-accept='" + esc(f.accept || 'image/*') + "'" +
          " data-atc-label='" + esc(f.label || 'Photo {n}') + "'" +
          " data-atc-btn='" + esc(f.button || 'Choose a file') + "'" +
          " data-atc-empty='" + esc(f.empty || 'No file chosen') + "'" +
          " data-atc-rmlabel='" + esc(f.removeLabel || 'Remove') + "'>"
        );
        html.push("<div data-atc-slots></div>");
        html.push("<button type='button' class='atc-ct__addbtn' data-atc-add>" + esc(f.addLabel || '+ Add another photo') + "</button>");
        html.push("<p class='atc-ct__count' data-atc-count></p>");
        html.push("</div>");
        return;
      }

      var wide = f.wide || type === 'file' || type === 'textarea';
      var nm = "properties[" + esc(f.name) + "]";

      html.push("<div class='atc-ct__field" + (wide ? ' atc-ct__field--wide' : '') + "'>");
      html.push("<label for='" + id + "'>" + (f.label || esc(f.name)) + "</label>");

      if (type === 'select') {
        html.push("<select id='" + id + "' name='" + nm + "' data-atc-kind='select'>");
        html.push("<option value=''>" + esc(f.placeholder || 'No thanks') + "</option>");
        (f.options || []).forEach(function (o) {
          html.push("<option value='" + esc(o) + "'>" + esc(o) + "</option>");
        });
        html.push("</select>");
      } else if (type === 'file') {
        html.push("<span class='atc-ct__file'>");
        html.push(
          "<input id='" + id + "' type='file' class='atc-ct__fileinput' data-atc-kind='file'" +
          " name='" + nm + "'" +
          (f.accept ? " accept='" + esc(f.accept) + "'" : '') + ">"
        );
        html.push("<label class='atc-ct__filebtn' for='" + id + "'>" + esc(f.button || 'Choose a file') + "</label>");
        html.push("<span class='atc-ct__filename' data-atc-filename='" + id + "'>" + esc(f.empty || 'No file chosen') + "</span>");
        html.push("</span>");
      } else if (type === 'textarea') {
        html.push(
          "<textarea id='" + id + "' data-atc-kind='textarea'" +
          " name='" + nm + "'" +
          " maxlength='" + (parseInt(f.max, 10) || 300) + "'" +
          " placeholder='" + esc(f.placeholder || '') + "'></textarea>"
        );
      } else {
        var digits = f.mode === 'digits';
        html.push(
          "<input id='" + id + "'" +
          (f.mode === 'upper' ? " class='atc-ct-upper'" : '') +
          " type='text' data-atc-kind='text'" +
          (digits ? " inputmode='numeric'" : '') +
          " name='" + nm + "'" +
          " maxlength='" + (parseInt(f.max, 10) || 20) + "'" +
          " autocomplete='off'" +
          " data-atc-mode='" + esc(f.mode || 'free') + "'" +
          " placeholder='" + esc(f.placeholder || '') + "'>"
        );
      }

      html.push("</div>");
    });

    html.push("</div>");
    if (cfg.note) html.push("<p class='atc-ct__note'>" + esc(cfg.note) + "</p>");
    html.push("</div>");

    wrap.innerHTML = html.join('');
    return wrap;
  }

  function renumber(box) {
    var base = box.getAttribute('data-atc-filelist') || 'Photo';
    var tpl = box.getAttribute('data-atc-label') || 'Photo {n}';
    var min = parseInt(box.getAttribute('data-atc-min'), 10) || 1;
    var max = parseInt(box.getAttribute('data-atc-max'), 10) || 8;
    var slots = [].slice.call(box.querySelectorAll('[data-atc-slot]'));

    slots.forEach(function (s, i) {
      var n = i + 1;
      var input = s.querySelector('input[type="file"]');
      var lab = s.querySelector('[data-atc-slotlabel]');
      var rm = s.querySelector('[data-atc-rm]');
      if (input) input.name = 'properties[' + base + ' ' + n + ']';
      if (lab) lab.textContent = tpl.replace(/\{n\}/g, String(n));
      if (rm) rm.hidden = slots.length <= min;
    });

    var add = box.querySelector('[data-atc-add]');
    if (add) add.hidden = slots.length >= max;

    var count = box.querySelector('[data-atc-count]');
    if (count) {
      count.textContent = slots.length >= max
        ? ('Maximum ' + max + ' photos.')
        : (slots.length + ' of ' + max + ' photos.');
    }
  }

  function addSlot(box) {
    var max = parseInt(box.getAttribute('data-atc-max'), 10) || 8;
    if (box.querySelectorAll('[data-atc-slot]').length >= max) return;

    var id = 'atc-ct-fl' + (++UID);
    var blank = box.getAttribute('data-atc-empty') || 'No file chosen';

    var d = document.createElement('div');
    d.className = 'atc-ct__slot';
    d.setAttribute('data-atc-slot', '');
    d.innerHTML =
      "<label data-atc-slotlabel></label>" +
      "<span class='atc-ct__file'>" +
      "<input type='file' class='atc-ct__fileinput' data-atc-kind='file'>" +
      "<label class='atc-ct__filebtn'></label>" +
      "<span class='atc-ct__filename'></span>" +
      "<button type='button' class='atc-ct__rm' data-atc-rm></button>" +
      "</span>";

    var input = d.querySelector('input');
    var slotLabel = d.querySelector('[data-atc-slotlabel]');
    var btn = d.querySelector('.atc-ct__filebtn');
    var out = d.querySelector('.atc-ct__filename');
    var rm = d.querySelector('[data-atc-rm]');

    input.id = id;
    input.setAttribute('accept', box.getAttribute('data-atc-accept') || 'image/*');
    slotLabel.setAttribute('for', id);
    btn.setAttribute('for', id);
    btn.textContent = box.getAttribute('data-atc-btn') || 'Choose a file';
    out.textContent = blank;
    rm.textContent = box.getAttribute('data-atc-rmlabel') || 'Remove';

    input.addEventListener('change', function () {
      out.textContent = (this.files && this.files.length) ? this.files[0].name : blank;
    });

    rm.addEventListener('click', function () {
      if (d.parentNode) d.parentNode.removeChild(d);
      renumber(box);
    });

    box.querySelector('[data-atc-slots]').appendChild(d);
    renumber(box);
  }

  function isEmpty(el) {
    if (el.getAttribute('data-atc-kind') === 'file') {
      return !el.files || el.files.length === 0;
    }
    return String(el.value || '').trim() === '';
  }

  function wire(form, wrap) {
    [].slice.call(wrap.querySelectorAll('[data-atc-filelist]')).forEach(function (box) {
      var min = parseInt(box.getAttribute('data-atc-min'), 10) || 1;
      for (var i = 0; i < min; i++) addSlot(box);
      var add = box.querySelector('[data-atc-add]');
      if (add) {
        add.addEventListener('click', function () { addSlot(box); });
      }
    });

    [].slice.call(wrap.querySelectorAll('input, select, textarea')).forEach(function (el) {
      var kind = el.getAttribute('data-atc-kind');

      if (kind === 'text') {
        var mode = el.getAttribute('data-atc-mode');
        el.addEventListener('input', function () {
          if (mode === 'digits') {
            this.value = this.value.replace(/[^0-9]/g, '');
          } else if (mode === 'upper') {
            this.value = this.value.toUpperCase().replace(/[^A-Z0-9 &'-]/g, '');
          }
        });
      }

      if (kind === 'file') {
        var out = wrap.querySelector('[data-atc-filename="' + el.id + '"]');
        if (!out) return;
        var blank = out.textContent;
        el.addEventListener('change', function () {
          out.textContent = (this.files && this.files.length) ? this.files[0].name : blank;
        });
      }
    });

    if (wrap.querySelector('[data-atc-kind="file"]') || wrap.querySelector('[data-atc-filelist]')) {
      form.setAttribute('enctype', 'multipart/form-data');
    }

    function allFields() {
      return [].slice.call(wrap.querySelectorAll('input, select, textarea'));
    }

    var restoring = 0;
    function strip() {
      allFields().forEach(function (el) { el.disabled = isEmpty(el); });
      clearTimeout(restoring);
      restoring = setTimeout(function () {
        allFields().forEach(function (el) { el.disabled = false; });
      }, 400);
    }

    form.addEventListener('submit', strip, true);
    form.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-atc-ct]')) return;
      strip();
    }, true);
  }

  function inject() {
    var form = mainForm();
    if (!form) return;
    if (form.querySelector('[data-atc-ct]')) return;

    addStyle();
    var wrap = build(config());
    var submit = form.querySelector('[type="submit"]');
    var anchor = submit ? (submit.closest('.product-form-buttons, .product-form__buttons, buy-buttons-component') || submit) : null;

    if (anchor && anchor.parentNode && form.contains(anchor)) {
      anchor.parentNode.insertBefore(wrap, anchor);
    } else {
      form.appendChild(wrap);
    }
    wire(form, wrap);
  }

  function start() {
    inject();
    var mo = new MutationObserver(function () { inject(); });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
